//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';

/**
 * Access the auth slice (state + methods).  Consumers that only need auth
 * subscribe here, so they re-render on auth changes only — not on unrelated
 * dataset/query/config state changes.
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context)
    throw new Error('useAuth must be used within an AuthProvider');

  return context;
}
